import http from './request'

// 获取开发者信息
export const getDevUserInfo = (data) => {
  return http({
    url: '/bizBase/Developer/getUserInfo',
    method: 'post',
    data
  })
}
